import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { isEmpty } from 'lodash';

import { Alert } from 'react-bootstrap';

export default function Errors({
  className,
  description = 'The following errors prevented the form from saving:',
  errors,
}) {
  return (
    <div>
      {errors && !isEmpty(errors) && (
        <Alert bsStyle="warning" className={classNames(className)}>
          {description}
          {errors.map(error => (
            <div key={error}>
              {error}
            </div>
          ))}
        </Alert>
      )}
    </div>
  );
}

Errors.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};
